import styled from '@emotion/styled'

export const Container = styled('div')`
  width: 100%;
  padding: 40px;
  overflow: hidden;
  position: relative;
`

export const Title = styled('p')`
  font-weight: 400;
  font-size: 24px;
`



export const ContainerTab = styled('div')`
  width: 100%;
  box-shadow: 0 0.5px 0 #c6c6c8;
  padding: 0.5px;
  display: flex;
`

export const Tab = styled('span')<{ select?: boolean }>`
  cursor: pointer;
  margin-right: 24px;
`

export const TitleTab = styled('p')<{ select?: boolean }>`
  font-size: 14px;
  color: ${(props) => (props.select ? '#009640' : '#000000')};
  box-shadow: ${(props) => (props.select ? 'inset 0px -2px 0px #009640' : 'unset')};
  margin-bottom: 0;
  padding: 14px 0;
`
